import { type MouseEvent, type PropsWithChildren, useEffect, useRef } from 'react'
import classes from './dialog.module.css'

export type DialogProps = PropsWithChildren<{
  open: boolean
  onClose: () => void
}>

export function Dialog(props: DialogProps) {
  const { children, open, onClose } = props

  const dialogRef = useRef<HTMLDialogElement>(null)
  useEffect(() => {
    const dialog = dialogRef.current
    if (open) {
      dialog?.showModal()
    } else {
      dialog?.close()
    }
  }, [open])

  function handleOnClick(event: MouseEvent<HTMLDialogElement>) {
    const target = event.target as HTMLDialogElement
    const rect = target.getBoundingClientRect()

    if (
      rect.left > event.clientX ||
      rect.right < event.clientX ||
      rect.top > event.clientY ||
      rect.bottom < event.clientY
    ) {
      dialogRef.current?.close()
    }

    const dialog = dialogRef.current
    if (dialog && target === dialog) {
      onClose()
    }
  }

  return (
    <dialog className={classes.dialog} id="search-dialog" onClick={handleOnClick} onClose={onClose} ref={dialogRef}>
      {children}
    </dialog>
  )
}
